import { QuizQuestionType } from 'redux/schemas/models/quiz';
import { gray5 } from 'styles/global_defaults/colors';
import { largeSpacing } from 'styles/global_defaults/scaffolding';
import { ReactComponent as CheckedBox } from 'styles/icons/checked-box.svg';
import { ReactComponent as UncheckedBox } from 'styles/icons/unchecked-box.svg';
import { ReactComponent as SelectedRadio } from 'styles/icons/selected-radio.svg';
import { ReactComponent as UnselectedRadio } from 'styles/icons/unselected-radio.svg';

type SelectedIndicatorProps = {
  color: string;
  selected: boolean;
  unselectedClassName?: string;
  questionType: QuizQuestionType;
};

const SelectedIndicator = (props: SelectedIndicatorProps) => {
  const { color, selected, questionType, unselectedClassName } = props;

  const isMultipleAnswer = questionType === QuizQuestionType.MULTIPLE_CHOICE_MULTIPLE_ANSWER;

  const commonProps = {
    width: largeSpacing,
    height: largeSpacing,
    color: selected ? color : gray5,
  };

  if (isMultipleAnswer) {
    return selected
      ? <CheckedBox {...commonProps} /> : <UncheckedBox {...commonProps} className={unselectedClassName} />;
  }

  return selected ? <SelectedRadio {...commonProps} /> : <UnselectedRadio {...commonProps} className={unselectedClassName} />;
};

export default SelectedIndicator;
